import { Breadcrumbs } from "../components/Breadcrumbs";
import { useSeo } from "../lib/seo";

export default function About() {
  useSeo({
    title: "About ProfitMigo — How Our Calculators Are Built & Tested",
    description: "ProfitMigo builds transparent profit, pricing and marketplace calculators for sellers. Learn who we are, how our formulas are developed and tested, and how we source assumptions.",
    path: "/about",
  });

  return (
    <div className="mx-auto max-w-3xl px-4 py-8 sm:px-6">
      <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "About" }]} />
      <h1 className="font-display text-4xl font-bold tracking-tight sm:text-5xl">About ProfitMigo</h1>

      <div className="mt-6 space-y-4 text-base leading-relaxed text-foreground/80">
        <p>ProfitMigo builds free, transparent calculators that help e-commerce sellers, freelancers and small businesses understand their real profit — not just price minus cost.</p>

        <h2 className="pt-4 font-display text-2xl font-semibold text-foreground">Why we exist</h2>
        <p>Most "profit" numbers sellers see ignore the costs that actually matter: marketplace commission, shipping, packaging, payment fees, advertising, GST and returns. Our tools include those costs so you can price with confidence.</p>

        <h2 className="pt-4 font-display text-2xl font-semibold text-foreground">How our calculations are developed</h2>
        <p>Every calculator runs on a single, shared formula engine rather than duplicated formulas per page. The engine is covered by automated unit tests for profit, margin, markup, ROI, break-even, selling price and marketplace calculations. Each page shows its methodology, a worked example and its assumptions.</p>

        <h2 className="pt-4 font-display text-2xl font-semibold text-foreground">How we handle external data</h2>
        <p>We do not hard-code marketplace fees as permanent facts because they change and vary by category. Instead, fee fields are editable inputs, and default assumptions are labelled with the date they were last reviewed. We never invent search volume, fees or statistics — if something is unknown, we say so.</p>

        <h2 className="pt-4 font-display text-2xl font-semibold text-foreground">How often we review</h2>
        <p>Assumptions and fee defaults are reviewed periodically and updated with a visible "last updated" date. If you spot something that looks off, please tell us via the contact page.</p>
      </div>
    </div>
  );
}
